module.exports = __webpack_public_path__ + "img/naotu_2.5d47711c.png";